import { css } from "styled-components";
import { LightboxClose } from "../../../../components/Lightbox";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
import { Icon } from "../../../../components/Icon";
export const riotProductSkin = (chroma, paletteTokens) => css `
  background-color: ${chroma.palettes.palette2.bladebg1};
  ${chroma.typography.body3};
  display: flex;
  color: ${chroma.palettes.palette2.bladetext1};
  flex-direction: column;
  max-width: 1056px;
  padding: 112px 0 120px 0;
  width: 90vw;
  cursor: default;

  ${chroma.mediaQueries.tabletDown} {
    width: 582px;
  }

  ${chroma.mediaQueries.mobileDown} {
    width: 366px;
    padding: 80px 0;
  }

  align-items: center;
  justify-content: space-between;
  position: relative;

  ${LightboxClose} {
    width: 40px;
    height: 40px;
    background-color: ${chroma.palettes.palette2.ctabg1};
  }

  ${Icon}.close-icon {
    background-color: ${chroma.palettes.palette2.ctatext1};
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .header h3 {
    ${chroma.typography.display5};
    ${textUppercaseMixin};
    max-width: 784px;
    color: ${chroma.palettes.palette2.bladetext1};
    ${chroma.mediaQueries.mobileDown} {
      max-width: 286px;
      font-size: 26px;
      font-weight: 400px;
    }
  }

  .header p {
    ${chroma.typography.body3};
    margin-top: 40px;
    max-width: 512px;
    text-align: center;
    color: ${chroma.palettes.palette2.bladetext1};

    ${chroma.mediaQueries.mobileDown} {
      max-width: 286px;
      font-size: 14px;
    }
  }

  .main-content {
    max-width: 784px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 64px;
  }

  .buttons {
    display: flex;
    justify-content: center;
    gap: 32px;
    ${chroma.mediaQueries.mobileDown} {
      flex-direction: column;
      width: 100%;
      gap: 16px;
    }
  }

  .buttons p {
    color: ${chroma.palettes.palette2.bladetext1};
  }

  .button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    text-align: center;

    a {
      cursor: pointer;
      ${textUppercaseMixin};
      width: 240px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      word-break: normal;
      ${chroma.mediaQueries.mobileDown} {
        width: 238px;
      }
    }

    .variant-primary {
      background-color: ${chroma.palettes.palette2.ctabg1};
      color: ${chroma.palettes.palette2.ctatext1};

      &::after {
        background-color: ${chroma.palettes.palette2.ctastroke1};
      }
    }

    .variant-secondary {
      background-color: ${chroma.palettes.palette2.ctabg2};
      color: ${chroma.palettes.palette2.ctatext2};

      &::after {
        background-color: ${chroma.palettes.palette2.ctastroke2};
      }
    }
  }

  .subtext {
    margin-top: 64px;

    p {
      color: ${paletteTokens.accents1};
    }

    a {
      ${chroma.typography.body3};
      font-weight: 400;
      color: ${paletteTokens.accents1};
    }
  }
`;
//# sourceMappingURL=rsoModal.js.map